import { render, staticRenderFns } from "./layout-tree.vue?vue&type=template&id=208d4b38&scoped=true&lang=pug&"
import script from "./layout-tree.vue?vue&type=script&lang=js&"
export * from "./layout-tree.vue?vue&type=script&lang=js&"
import style0 from "./layout-tree.vue?vue&type=style&index=0&id=208d4b38&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d4b38",
  null
  
)

export default component.exports